import React from 'react'
import { isEmpty } from 'lodash'

import { SearchOptions } from './SearchOptions'
import { ResultsList } from './ResultsList'

type PropsType = {
  result: any //SearchResultsType
  totalGoods: number
  totalOffers: number
}

export const ProductsView: React.FC<PropsType> = ({
  result: {
    data: { good, originalCrosses, crosses },
    loading,
  },
  totalGoods,
  totalOffers,
}) => (
  <div className="products-view">
    <SearchOptions
      totalGoods={totalGoods}
      totalOffers={totalOffers}
      loading={loading}
    />
    {good && <ResultsList items={good ? [good] : []} title="Искомый артикул" />}
    {!isEmpty(originalCrosses) && (
      <ResultsList items={originalCrosses} title="Оригинальные замены" />
    )}
    {!isEmpty(crosses) && <ResultsList items={crosses} title="Аналоги" />}
    {/* <Pagination /> */}
  </div>
)
